import { c as _c } from "react/compiler-runtime";
import { getOsType, getSubDomain, isEnumValue } from '@core/utils';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { SUB_DOMAIN } from '@/constants/domain';
import { detectWebviewType, WEBVIEW_TYPE } from '@/utils/webviewType';
import { useDeviceInfoStore } from './useDeviceInfoStore';
export const useMountDeviceInfoStore = () => {
  const $ = _c(7);
  const [setIsMounted, setWebviewType, setOsType, setViewportType, setSubDomain] = useDeviceInfoStore(useShallow(_temp));
  let t0;
  let t1;
  if ($[0] !== setIsMounted || $[1] !== setOsType || $[2] !== setSubDomain || $[3] !== setViewportType || $[4] !== setWebviewType) {
    t0 = () => {
      const subDomain = getSubDomain();
      const {
        userAgent
      } = navigator;
      setOsType(getOsType());
      setViewportType(/Mobile/.exec(userAgent) ? "mobile" : "desktop");
      const webviewTypeByUserAgent = detectWebviewType(userAgent);
      if (webviewTypeByUserAgent === WEBVIEW_TYPE.WELLO_APP) {
        setWebviewType(WEBVIEW_TYPE.WELLO_APP);
      }
      if (isEnumValue(SUB_DOMAIN, subDomain)) {
        setSubDomain(subDomain);
        bb12: switch (subDomain) {
          case SUB_DOMAIN.KB_PAY:
            {
              if (webviewTypeByUserAgent === WEBVIEW_TYPE.KB_PAY) {
                setWebviewType(WEBVIEW_TYPE.KB_PAY);
              }
              break bb12;
            }
          case SUB_DOMAIN.TOSS:
            {
              if (webviewTypeByUserAgent === WEBVIEW_TYPE.TOSS) {
                setWebviewType(WEBVIEW_TYPE.TOSS);
              }
              break bb12;
            }
          default:
        }
      } else {
        setSubDomain(null);
      }
      setIsMounted(true);
    };
    t1 = [setIsMounted, setOsType, setSubDomain, setViewportType, setWebviewType];
    $[0] = setIsMounted;
    $[1] = setOsType;
    $[2] = setSubDomain;
    $[3] = setViewportType;
    $[4] = setWebviewType;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
};
function _temp(state) {
  return [state.setIsMounted, state.setWebviewType, state.setOsType, state.setViewportType, state.setSubDomain];
}